import vintageAirDevDefaults from '../xovjmui41g-1/config.js';

export default {
  ...vintageAirDevDefaults,
  includes: ['xovjmui41g-1'],
};
